import { OnEventDispatcher } from "../core/on-event-dispatcher";
import { GoogleMaps, MarkerGroup } from "../core/googlemaps";
import { Receptions } from "../io/receptions";
import { Application } from "../main";
import { VaxiluskernaMap } from "./vaxiluskernamap";

const VaxiluskernaIconProps = {
    srcWidth: 62,
    srcHeight: 76,
    displayWidth: 31,
    displayHeight: 38
}
export type VaxiluskernaMarkerOptions = {
    icon: {
        idle: string,
        highlight: string,
        peripheral: string,
        tiny: string,
        tinyperipheral: string
    },
    title: string,
    position:{lat:number, lng:number},
    group:string

}
export class VaxiluskernaMarker extends OnEventDispatcher {
    
    map: VaxiluskernaMap;
    options: VaxiluskernaMarkerOptions;

    idleSymbol: string;
    highlightSymbol: string;
    marker: google.maps.marker.AdvancedMarkerElement;
    private iconEl: HTMLImageElement;
    selected: boolean = false;
    hovered: boolean;
    _opacity:number = 1;
    markerGroup: MarkerGroup;
    //isClustered:boolean;
    hidden:boolean = false;
    peripheral:boolean = false;
    peripheralSymbol: string;
    isWithinBounds: boolean;
    tinySymbol: string;
    tinyPeripheralSymbol: string;

    constructor(map:VaxiluskernaMap, options:VaxiluskernaMarkerOptions) {
        
        super();
        this.map = map;
        this.options = options;

        this.idleSymbol = this.options.icon.idle;
        this.peripheralSymbol = this.options.icon.peripheral;
        this.highlightSymbol = this.options.icon.highlight;
        this.tinySymbol = this.options.icon.tiny;
        this.tinyPeripheralSymbol = this.options.icon.tinyperipheral;
        
        
        this.iconEl = document.createElement("img");
        this.iconEl.src = this.idleSymbol;
        this.iconEl.width = VaxiluskernaIconProps.displayWidth;
        this.iconEl.height = VaxiluskernaIconProps.displayHeight;
        this.iconEl.alt = this.options.title ?? "";
        this.iconEl.style.transform = "translateY(0px)";

        this.marker = new google.maps.marker.AdvancedMarkerElement({
            map: this.map.googlemaps.map,
            position: this.options.position as any,
            title: null,
            content: this.iconEl,
            zIndex: 0,
        } as any);

        // keep markerGroups behavior consistent
        if(this.map.googlemaps.markerGroups[this.options.group]==null) {
            // MarkerGroup exists in googlemaps.ts; create via map.googlemaps.addMarkerGroup if present, else ensure group exists
            (this.map.googlemaps.markerGroups as any)[this.options.group] = (this.map.googlemaps.markerGroups as any)[this.options.group] ?? { markers: [] };
        }
        // markerGroups[group].markers is an array
        (this.map.googlemaps.markerGroups as any)[this.options.group].markers.push(this.marker);

        this.markerGroup = (this.map.googlemaps.markerGroups as any)[this.options.group];

        // Hover events: attach to the marker content element
        this.iconEl.addEventListener("mouseenter", () => {
            this.hovered = true;
            this.map.showTooltip(this.options.title);
            this.updateIcon();
        });
        this.iconEl.addEventListener("mouseleave", () => {
            this.hovered = false;
            this.map.hideTooltip();
            this.updateIcon();
        });

        // Click event: AdvancedMarkerElement uses the `gmp-click` event
        (google.maps.event as any).addListener(this.marker as any, "gmp-click", () => {
            this.dispatch("click");
        });

        this.updateIcon();
    }

    updateIcon() {
        if(this.selected) {
            this.iconEl.src = this.highlightSymbol;
            (this.marker as any).zIndex = 10;
        } else {
            if(Receptions.visibleMarkerCount>80) {
                if(this.peripheral) {
                    this.iconEl.src = this.tinyPeripheralSymbol;
                    (this.marker as any).zIndex = 0;
                } else {
                    if(Application.receptionSearchResultCount==0) {
                        this.iconEl.src = this.tinySymbol;
                        (this.marker as any).zIndex = 1;
                    } else {
                        if(this.hovered) {
                            this.iconEl.src = this.highlightSymbol;
                            (this.marker as any).zIndex = 9;
                        } else {
                            this.iconEl.src = this.idleSymbol;
                            (this.marker as any).zIndex = 2;
                        }
                    }
                }
            } else {
                if(this.peripheral) {
                    this.iconEl.src = this.peripheralSymbol;
                    (this.marker as any).zIndex = 0;
                } else {
                    if(this.hovered) {
                        this.iconEl.src = this.highlightSymbol;
                        (this.marker as any).zIndex = 9;
                    } else {
                        this.iconEl.src = this.idleSymbol;
                        (this.marker as any).zIndex = 2;
                    }
                }
            }
        }
    }

    onMapBounds(mapBounds: google.maps.LatLngBounds) {
        this.isWithinBounds = mapBounds.contains(this.options.position);
    }

    setPeripheral(peripheral:boolean) {
        this.peripheral = peripheral;
        this.updateIcon();
    }
    setSelected(selected:boolean) {
        this.selected = selected;
        this.updateIcon();
    }

    setHide(hidden:boolean) {
        if(hidden&&!this.hidden) {
            this.hidden = true;
            this.marker.map = null;
        } else if(!hidden&&this.hidden) {
            this.hidden = false;
            this.marker.map = this.map.googlemaps.map;
        }
    }
}